import { ComponentProps, type FC } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { cn } from '~/utils'
import { Badge } from '~/elements'

export type RequiredVersionBadgeProps = {
  version: string
} & Omit<ComponentProps<typeof Badge>, 'children'>

export const RequiredVersionBadge: FC<RequiredVersionBadgeProps> = ({ version, className, ...props }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="secondary"
          className={cn(
            'rounded-md px-2 py-0.5 font-mono text-xs',
            'border border-border/50 bg-muted/50 text-muted-foreground',
            'transition-colors hover:bg-muted/70',
            'group-data-[state=checked]:border-primary/30 group-data-[state=checked]:bg-primary/15 group-data-[state=checked]:text-primary',
            'group-data-[state=checked]:hover:bg-primary/20',
            className
          )}
          {...props}
        >
          v{version}+
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-[200px] text-center text-xs">
        <p>This feature is only available with Webchat v{version}+</p>
      </TooltipContent>
    </Tooltip>
  )
}
